module.exports = __webpack_public_path__ + "static/media/80.36dcc1b7.gif";